export default __webpack_public_path__ + "static/media/A21.58e0a7e9.png";